import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CosaFacciamoPage from './pages/CosaFacciamoPage';
import ChiSiamoPage from './pages/ChiSiamoPage';
import LaCasaPage from './pages/LaCasaPage';
import IlMetodoPage from './pages/IlMetodoPage';
import ContattiPage from './pages/ContattiPage';
import PrivacyPage from './pages/PrivacyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import TermsPage from './pages/TermsPage';
import InformativaOspitiPage from './pages/InformativaOspitiPage';
import InformativaCollaboratoriPage from './pages/InformativaCollaboratoriPage';
import ErrorPage from './pages/ErrorPage';
import Layout from './components/Layout';
import './App.css';
import './styles/responsive.css';
import './styles/public-responsive.css'; // Aggiunto per le pagine pubbliche, home etc.
import DashboardPage from './pages/DashboardPage';
import ProtectedRoute from './utils/ProtectedRoute';
import ProfilePage from './pages/ProfilePage';
import ResearchNotesPage from './pages/ResearchNotesPage';
import { AuthProvider } from './services/authContext';
import LoginRedirect from './components/LoginRedirect';
import CookieConsent from './components/CookieConsent';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/chi-siamo',
        element: <ChiSiamoPage />,
      },
      {
        path: '/cosa-facciamo',
        element: <CosaFacciamoPage />,
      },
      {
        path: '/la-casa',
        element: <LaCasaPage />,
      },
      {
        path: '/il-metodo',
        element: <IlMetodoPage />,
      },
      {
        path: '/contatti',
        element: <ContattiPage />,
      },
      {
        path: '/privacy',
        element: <PrivacyPage />,
      },
      {
        path: '/cookie-policy',
        element: <CookiePolicyPage />,
      },
      {
        path: '/terms',
        element: <TermsPage />,
      },
      {
        path: '/informativa-ospiti',
        element: <InformativaOspitiPage />,
      },
      {
        path: '/informativa-collaboratori',
        element: <InformativaCollaboratoriPage />,
      },
      {
        path: '/login',
        element: <LoginRedirect />,
      },
      {
        path: '/areaOperatori',
        element: (
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/areaDirettore',
        element: (
          <ProtectedRoute allowedRoles={['direttore']}>
            <DashboardPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/areaEducatori',
        element: (
          <ProtectedRoute allowedRoles={['educatore']}>
            <DashboardPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/ricercaNoteOspite',
        element: (
          <ProtectedRoute>
            <ResearchNotesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: '/profilo',
        element: (
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);

const App = () => {
  return (
    <AuthProvider>
      <div className="app-container">
        <RouterProvider router={router} />
        <CookieConsent />
      </div>
    </AuthProvider>
  );
};

export default App;
